import React from "react";
import { useParams } from "react-router-dom";
import useGetMutexData from "../../hooks/useGetMutexData";
import { mutex } from "./schema";
import DynamicAnalysisGrid from "../../../common/dynamicanalysis/DynamicAnalysisGrid";

const MutexGrid = () => {
  const { hash, uploadId } = useParams();
  const { data } = useGetMutexData(hash, uploadId);

  return <DynamicAnalysisGrid data={data} schema={mutex} />;
};

export default MutexGrid;
